import { Type } from '@sinclair/typebox';
import { NullishType } from './standard-schema.js';
export const GuestProjectDetailsSchema = Type.Object({
    id: Type.String(),
    fortnoxId: NullishType(Type.String()),
    name: Type.String(),
    status: NullishType(Type.String()),
    type: NullishType(Type.String()),
    size: NullishType(Type.Number()),
    compensationForm: NullishType(Type.String()),
    contractorType: NullishType(Type.String()),
    contractSum: NullishType(Type.Number()),
    startDate: NullishType(Type.String()),
    endDate: NullishType(Type.String()),
    ataSum: NullishType(Type.Number()), // ÄTA-summa
});
export const GetGuestProjectDetailsParamsSchema = Type.Object({
    id: Type.String(),
});
export const GetGuestProjectDetailsResponseSchema = GuestProjectDetailsSchema;
